import { useMemo } from 'react';
import { getSectionScaleValueByWindowWidth } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import useWindowResize from './useWindowResize';

const useCurrentScale = (coefficient?: number): number => {
  const { width: windowWidth, height: windowHeight } = useWindowResize();
  const currentScale = useMemo(
    () => getSectionScaleValueByWindowWidth(windowWidth, windowHeight, coefficient),
    [windowWidth, windowHeight]
  );

  return currentScale;
};

export default useCurrentScale;
